import { render, staticRenderFns } from "./ProcedureItem.vue?vue&type=template&id=715ed104&scoped=true&"
import script from "./ProcedureItem.vue?vue&type=script&lang=js&"
export * from "./ProcedureItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureItem.vue?vue&type=style&index=0&id=715ed104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ed104",
  null
  
)

export default component.exports